import { Alert } from '@stratascratch/ui'
import { PLATFORM_BASE_URL } from '../../constants'

export function PythonMessage() {
  return (
    <Alert type="info">
      <div>
        <ul>
          <li className="list-disc text-sm">
            The dataset has already been loaded as a pandas.DataFrame.
          </li>
          <li className="list-disc text-sm">
            print() functions and the last line of code will be displayed in the
            output.
          </li>
          <li className="list-disc text-sm">
            In order for your solution to be accepted, your solution should be
            located on the last line of the editor and match the expected output
            data type listed in the question.
          </li>
        </ul>
      </div>
    </Alert>
  )
}

interface ErrorInsetProps {
  children: React.ReactNode
}

function ErrorInset({ children }: ErrorInsetProps) {
  return (
    <div className="bg-(--bg-color-dim) z-5 absolute inset-8 flex flex-col items-center justify-center text-center font-bold">
      {children}
    </div>
  )
}

export function AuthMessage() {
  const loginUrl = `${PLATFORM_BASE_URL}/login?next=${window.location.toString()}`

  return (
    <ErrorInset>
      <p>
        You have reached your daily limit for code executions on our blog.
        <br />
        Please{' '}
        <a href={loginUrl} className="text-(--color-link)">
          login/register
        </a>{' '}
        to execute more code.
      </p>
    </ErrorInset>
  )
}

export function LoadErrorMessage() {
  return (
    <ErrorInset>
      <p>
        An error loading data has occured, this shouldn't have happened.
        <br />
        If the problem persists, contact support at{' '}
        <a href="mailto:team@stratascratch.com" className="text-(--color-link)">
          team@stratascratch.com
        </a>
        .
      </p>
    </ErrorInset>
  )
}
